import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { inject } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomButton',
  emits: ["click-submit"],
  setup(__props, { emit: emits }) {

const isMove = inject("isMove", false);


function submit() {
  emits("click-submit");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'submit-button': _unref(isMove), 'pc-submit-button': !_unref(isMove) }),
    onClick: submit
  }, "MAKE PAYMENT", 2))
}
}

})